"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaBreakpointPropertyMixin = exports.MediaBreakpointMixin = void 0;
const forEach_1 = __importDefault(require("lodash/forEach"));
const isString_1 = __importDefault(require("lodash/isString"));
const isUndefined_1 = __importDefault(require("lodash/isUndefined"));
const styled_components_1 = require("styled-components");
const breakpoint_1 = require("../../utils/breakpoint");
const MediaBreakpointMixin = (props) => {
    return (0, styled_components_1.css) `
    ${({ theme: { breakpoints } }) => {
        const breakpointRanges = (0, breakpoint_1.breakpointsToBreakpointRanges)(breakpoints);
        const breakpointKeys = Object.keys(props);
        return breakpointKeys
            .filter((v) => !(0, isUndefined_1.default)(breakpointRanges[v]))
            .map((key) => {
            const [min, max] = breakpointRanges[key];
            let query = '@media all';
            if (min) {
                query += ` and (min-width: ${min}px)`;
            }
            if (max) {
                query += ` and (max-width: ${max}px)`;
            }
            return (0, styled_components_1.css) `
            ${query} {
              ${props[key]}
            }
          `;
        });
    }}
  `;
};
exports.MediaBreakpointMixin = MediaBreakpointMixin;
const MediaBreakpointPropertyMixin = (name, values, options = {}) => {
    const important = options.important ? ' !important' : '';
    if ((0, isString_1.default)(values)) {
        return (0, styled_components_1.css) `
      ${name}: ${values} ${important}
    `;
    }
    const breakpoints = {};
    (0, forEach_1.default)(values, (v, k) => {
        breakpoints[k] = (0, styled_components_1.css) `
      ${name}: ${v} ${important};
    `;
    });
    return (0, exports.MediaBreakpointMixin)(breakpoints);
};
exports.MediaBreakpointPropertyMixin = MediaBreakpointPropertyMixin;
